import { type ApiRentVariant } from '@Model';
import {
    Card,
    Grid,
    GridColumns,
    type IGuiBinder,
    NumberInput,
    useProp,
    useTranslate,
} from '@synqo/frontend-component-library';
import { memo } from 'react';

// @ai-generated 2026-10-22T11:31:29+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)

interface IProps {
    binder: IGuiBinder<ApiRentVariant>;
}

export const RentVariantConditionsSection = memo(function RentVariantConditionsSection({ binder }: IProps) {
    const i18n = useTranslate('');

    const freeDaysAfterPlacementField = useProp<ApiRentVariant, number>(binder, 'free_days_after_placement');
    const freeDaysAfterExchangeField = useProp<ApiRentVariant, number>(binder, 'free_days_after_exchange');

    return (
        <Card name="conditions" label="Konditionen">
            <Grid>
                <GridColumns spans={[6, 6]}>
                    <NumberInput
                        {...freeDaysAfterPlacementField}
                        decimals={0}
                        label={i18n('Freie Tage nach Stellung')}
                    />
                    <NumberInput {...freeDaysAfterExchangeField} decimals={0} label={i18n('Freie Tage nach Tausch')} />
                </GridColumns>
            </Grid>
        </Card>
    );
});
